import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNetworkWired, faCheckCircle, faPauseCircle, faPlug } from '@fortawesome/pro-solid-svg-icons'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { getAccessToken } from '../../services/auth.service'
import { NewestConnectionsCard } from '../../components/NewestConnectionsCard'
import { ChangedConnectionsCard } from '../../components/ChangedConnectionsCard'

export function Dashboard() {
  const constructionStatsQuery = useQuery({
    queryKey: ['stats', 'construction'],
    queryFn: async () => {
      const response = await fetch('/api/netwerk/aansluitingen/stats?under_construction=true', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getAccessToken()}`,
        },
      })

      if (!response.ok) {
        throw new Error(response.statusText)
      }
      return response.json()
    },
  })

  const completedStatsQuery = useQuery({
    queryKey: ['stats', 'completed'],
    queryFn: async () => {
      const response = await fetch('/api/netwerk/aansluitingen/stats?under_construction=false', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getAccessToken()}`,
        },
      })

      if (!response.ok) {
        throw new Error(response.statusText)
      }
      return response.json()
    },
  })

  return (
    <>
      {/* Start with 4 columns info boxes */}
      <div className="row">
        <div className="col-lg-3 col-6">
          {/* small box */}
          <div className="small-box bg-info">
            <div className="inner">
              <h3>
                {completedStatsQuery.data?.totalConnections}
                <small style={{ fontSize: '0.5em', opacity: 0.6, marginLeft: '0.5rem' }}>
                  +{constructionStatsQuery.data?.totalConnections}
                </small>
              </h3>
              <p>Totaal aantal aansluitingen</p>
            </div>
            <div className="icon">
              <FontAwesomeIcon icon={faNetworkWired as IconProp} />
            </div>
          </div>
        </div>
        {/* ./col */}
        <div className="col-lg-3 col-6">
          {/* small box */}
          <div className="small-box bg-danger">
            <div className="inner">
              <h3>
                {completedStatsQuery.data?.ftuCount}
                <small style={{ fontSize: '0.5em', opacity: 0.6, marginLeft: '0.5rem' }}>
                  +{constructionStatsQuery.data?.ftuCount}
                </small>
              </h3>
              <p>FTU Only</p>
            </div>
            <div className="icon">
              <FontAwesomeIcon icon={faPlug as IconProp} />
            </div>
          </div>
        </div>
        {/* ./col */}
        <div className="col-lg-3 col-6">
          {/* small box */}
          <div className="small-box bg-warning">
            <div className="inner">
              <h3>
                {completedStatsQuery.data?.inactiveCount}
                <small style={{ fontSize: '0.5em', opacity: 0.6, marginLeft: '0.5rem' }}>
                  +{constructionStatsQuery.data?.inactiveCount}
                </small>
              </h3>
              <p>Inactieve aansluitingen</p>
            </div>
            <div className="icon">
              <FontAwesomeIcon icon={faPauseCircle as IconProp} />
            </div>
          </div>
        </div>
        {/* ./col */}
        <div className="col-lg-3 col-6">
          {/* small box */}
          <div className="small-box bg-success">
            <div className="inner">
              <h3>
                {completedStatsQuery.data?.abboCount}
                <small style={{ fontSize: '0.5em', opacity: 0.6, marginLeft: '0.5rem' }}>
                  +{constructionStatsQuery.data?.abboCount}
                </small>
              </h3>
              <p>Actieve aansluitingen</p>
            </div>
            <div className="icon">
              <FontAwesomeIcon icon={faCheckCircle as IconProp} />
            </div>
          </div>
        </div>
        {/* ./col */}
      </div>
      <div className="row">
        <div className="col-lg-6 col-12">
          <ChangedConnectionsCard />
        </div>
        <div className="col-lg-6 col-12">
          <NewestConnectionsCard />
        </div>
      </div>
    </>
  )
}
